// extracted by mini-css-extract-plugin
var _1 = "WarningBoxStyles-module__warning___BX5zy";
var _2 = "WarningBoxStyles-module__warning-icon___tun0x";
var _3 = "WarningBoxStyles-module__warning-text___mNfVi";
var _4 = "WarningBoxStyles-module__warning-icon___tun0x";
var _5 = "WarningBoxStyles-module__warning-text___mNfVi";
export { _1 as "warning", _2 as "warning-icon", _3 as "warning-text", _4 as "warningIcon", _5 as "warningText" }
